import { z } from 'zod';

export const paginationQuerySchema = z.object({
  cursor: z.string().nullish(),
  limit: z.coerce.number().int().min(1).max(100).default(25),
});

export type PaginationQuery = z.infer<typeof paginationQuerySchema>;

/** The collection response envelope every list endpoint returns. */
export interface PaginatedResponse<T> {
  readonly data: readonly T[];
  readonly pagination: {
    readonly nextCursor: string | null;
    readonly hasMore: boolean;
    readonly limit: number;
  };
}

export function buildPaginatedResponse<T>(
  items: readonly T[],
  nextCursor: string | null,
  hasMore: boolean,
  limit: number,
): PaginatedResponse<T> {
  return { data: items, pagination: { nextCursor, hasMore, limit } };
}
